import React from "react";
import {afiClassService} from "../jwt/_services/hotel/afiClassService";

export const afiClassProvider = {
    getOptions,
    getItem,
};

async function getOptions() {
    try {
        const dataRequest = {
            fbDataBase : { id : null },
            item : { code : null }
        }

        const listItems = await afiClassService.search(0,100, dataRequest);
        return listItems.data.map((itemData) => {
            return (
                {
                    id: itemData.id,
                    value: itemData.code,
                    label: <div><label>{itemData.code.toUpperCase() + ' - ' + itemData.name}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id) {
    try {
        const item = await afiClassService.getItem(id);

        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code.toUpperCase() + ' - ' + item.name}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}